import { lazy } from 'react';
import { MultiApp } from '@/config/context';
import { IRouteConfig } from '../types';

export const userRoutes = (): IRouteConfig[] => [
  {
    path: '/user/profile',
    exact: true,
    name: '个人信息',
    component: lazy(() => import('@/presentation/pages/user/profile')),
    hideInMenu: true,
    whitelisted: true,
    pmWhitelisted: true,
    versions: [MultiApp.Pro, MultiApp.Sgp],
  },
  {
    path: '/user/token',
    exact: true,
    name: '个人令牌',
    component: lazy(() => import('@/presentation/pages/user/token')),
    hideInMenu: true,
    whitelisted: true,
    pmWhitelisted: true,
    versions: [MultiApp.Pro, MultiApp.Sgp],
  },
];

export default userRoutes;
